import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import Confirm from "v4/components/ui/Confirm/Confirm";
import Table from "v4/components/ui/Table/Table";
import useDeletedCustomers
    from "v4/features/admin/deletedCustomers/components/DeletedCustomers/hooks/useDeletedCustomers";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import './DeletedCustomers.scss';
import {getFormattedValue} from "v4/utils";
import PolButton from "v4/components/ui/PolButton/PolButton";

export default function DeletedCustomers({refreshDeletedCustomers, refreshComponents}) {
    const {t} = usePolTranslation();
    const {
        deletedCustomersTable,
        onRestore,
        rowRestoring,
        closeRestoreConfirm,
        confirmRestore,
        isConfirmLoading,
    } = useDeletedCustomers(refreshDeletedCustomers, refreshComponents);

    if (!deletedCustomersTable.rows?.length) return null;

    return (
        <AdminCard title={t('planned_deletions')}
                   isPage={false}>
            <Table theme="admin"
                   theadData={deletedCustomersTable.headers}
                   tableRows={deletedCustomersTable.rows}
                   renderCell={(key, value, index, row) => {
                       if (key.toUpperCase() === 'LOGOURL') {
                           return <td key={key}><img src={value} alt="logo" height="40"/></td>
                       }

                       if (key.toUpperCase() === 'ACTIONS') {
                           return (
                               <td key={key}>
                                   <PolButton className="btn-primary deleted-customers__btn-restore" onClick={onRestore(row)}>
                                       <PolIcon icon="add"/>
                                   </PolButton>
                               </td>
                           );
                       }

                       if (key.toUpperCase() === 'DELETEDAT') {
                           return <td key={key}>{getFormattedValue('datetime', value, {keepTime: true})}</td>;
                       }

                       if (['buyingAt', 'expiredAt'].includes(key)) {
                           return <td key={key}>{getFormattedValue('date', value)}</td>;
                       }

                       return <td key={key}>{value}</td>;
                   }}/>
            <Confirm title="Restoration du client"
                     isOpen={!!rowRestoring}
                     closeAction={closeRestoreConfirm}
                     confirmAction={confirmRestore}
                     isLoading={isConfirmLoading}>
                <p>Vous êtes sur le point de restorer le client "<span
                    className="deleted-customers__customer-highlight">{rowRestoring?.name}</span>". Continuer ?</p>
            </Confirm>
        </AdminCard>
    )
}
